import * as React from "react";
import { Table } from "antd";
import { connect } from "react-redux";
import Refundde from "widget/tag/refund";

interface IRefundProps {
  number: any;
  refundlist: any;
  user: any;
  id: any;
  tabStatus: any;

}

// 修改
class Refund extends React.Component<IRefundProps, any> {
  state = {
    result: [],
    merge_order: [],
    refresh: true,
  };
  constructor(props: IRefundProps) {
    super(props);
  }
  componentDidMount() {
    this.refundlist();
  }

  shouldComponentUpdate(nextProps: any, prevState: any) {
    if (nextProps.tabStatus != 'tab4' && !prevState.refresh) {
      this.setState({
        refresh: true,
      });
      return true;
    }
    if (nextProps.tabStatus == 'tab4' && prevState.refresh) {
      this.refundlist();
      return false;
    }
    return true;
  }

  refundlist = () => {
    this.setState({
      refresh: false,
    });
    const param: any = {
      id: this.props.id
    };
    this.props.refundlist({
      ...param,
      callback: (data) => {
        this.setState({
          result: data.result,
          merge_order: data.merge_order,
        });
      }
    });
  }
  decodeBase64Content = (base64Content) => {
    let commonContent = base64Content.replace(/\s/g, '+');
    commonContent = Buffer.from(commonContent, 'base64').toString();
    return commonContent;
  }

  render() {
    const dataSource = this.state.result;
    const dataSourcemerge = this.state.merge_order;
    const columns = [{
      title: '退款编号',
      dataIndex: 'number',
      key: 'number',
      className: 'th',
      render: (text, row, index) => {
        return (
          <React.Fragment>
            <a href={row.url}>{row.number}</a>
          </React.Fragment>
        );
      }
    }, {
      title: '退款状态',
      dataIndex: 'status',
      key: 'status',
      className: 'th',

    }, {
      title: '负责人',
      dataIndex: 'creator',
      key: 'creator',
      className: 'th',

    }, {
      title: '日期',
      dataIndex: 'create_time',
      key: 'create_time',
      className: 'thl',
      render: (text, row, index) => {
        return (
          <React.Fragment>
            <p><strong>创建日期：{row.create_time}</strong></p>
            <p><strong>退款日期：{row.refund_time}</strong></p>
          </React.Fragment>
        );
      }
    }, {
      title: '退款金额￥',
      key: 'amount',
      dataIndex: 'amount',
      className: 'th',
    }, {
      title: '手续费￥',
      dataIndex: 'poundage',
      key: 'poundage',
      className: 'th',

    }, {
      title: '退款类型',
      dataIndex: 'refund_type',
      key: 'refund_type',
      className: 'th',

    }, {
      title: '退款途径',
      dataIndex: 'refund_channel_new',
      key: 'refund_channel_new',
      className: 'th',

    }, {
      title: '原因',
      dataIndex: 'reparation_reson',
      key: 'reparation_reson',
      className: 'th',

    }, {
      title: '描述',
      dataIndex: 'after_desc',
      key: 'after_desc',
      className: 'th',
      render: (text, row, index) => {
        return (
          <React.Fragment>
            <p>{row.after_desc}</p>
            {row.solution_detail ? <p>解决详情: {row.solution_detail}</p> : ''}
          </React.Fragment>
        );
      }
    }];


    return (
      <React.Fragment>
        <div className="from-after">
          <div className="after-head">
            <div className='ahead-left'>
              订单<span className="colour-blue">{this.decodeBase64Content(this.props.number)}</span>的退款记录
                       <Refundde tag={[5]} type="refund" pfn={this.refundlist} />
            </div>
          </div>
          <div className="table1">
            <Table bordered={true} expandIconAsCell={false} expandIconColumnIndex={-1} pagination={false} dataSource={dataSource} columns={columns} />
          </div>
          <div className="table3">
            <h3>订单<span className="colour-blue">{this.decodeBase64Content(this.props.number)}</span>的合并订单退款记录</h3>
            <Table bordered={true} expandIconAsCell={false} expandIconColumnIndex={-1} pagination={false} dataSource={dataSourcemerge} columns={columns} />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  number: state.orderDetails.number,
  id: state.orderDetails.id,
  user: state.userInfo.user,
  tabStatus: state.orderDetails.tabStatus,
});

const mapDispatch = dispatch => {
  return {
    refundlist: dispatch.orderDetails.refundlist
  };
};


export default connect(
  mapState,
  mapDispatch
)(Refund);
